(function () {
  // Na strance Inspirace se tento skript nacita 2x (hero + lookbook sekce).
  // Bez guardu by se document listenery zaregistrovaly dvakrat a klik na bod
  // by se otevrel a hned zase zavrel (toggle se vyrusi) → popover by se vubec
  // neukazal. Proto inicializujeme jen jednou.
  if (window.__pzShoppableInit) return;
  window.__pzShoppableInit = true;

  // Najdi popover, ktery patri k hotspotu (bezprostredni sourozenec).
  function popoverOf(btn) {
    var p = btn.nextElementSibling;
    return (p && p.matches && p.matches('[data-popover]')) ? p : null;
  }

  // --- Fixed-pozicovani popoveru ---
  // Lookbook pouziva CSS masonry (column-count), ktery orezava absolutne
  // pozicovane popovery. Pro stage s [data-shoppable-fixed] proto popover
  // pri otevreni prepneme na position:fixed a spocitame souradnice od bodu,
  // takze "vyskoci" mimo orez. Homepage marker nema → chova se jako drive.
  function positionFixed(btn) {
    var pop = popoverOf(btn);
    if (!pop) return;
    // Uloz puvodni inline left/top (z Liquidu, v %) jen jednou — pri zavreni
    // je vratime, aby popover "neutekl" do leveho rohu (desktop micro-bug).
    if (pop.dataset.pzOrigSaved !== '1') {
      pop.dataset.pzOrigLeft = pop.style.left || '';
      pop.dataset.pzOrigTop = pop.style.top || '';
      pop.dataset.pzOrigSaved = '1';
    }
    var r = btn.getBoundingClientRect();
    pop.style.position = 'fixed';
    pop.style.zIndex = '1000';
    pop.style.right = 'auto';
    pop.style.bottom = 'auto';
    // svisle: kotvime na stred bodu (CSS transform doladi posun/flip)
    pop.style.top = (r.top + r.height / 2) + 'px';
    // vodorovne: vycentruj na bod, ale drz kartu v okne
    var halfW = (pop.offsetWidth || 240) / 2;
    var cx = r.left + r.width / 2;
    cx = Math.max(halfW + 8, Math.min(window.innerWidth - halfW - 8, cx));
    pop.style.left = cx + 'px';
    // flip nahoru, kdyz pod bodem neni dost mista
    var flipUp = (window.innerHeight - (r.top + r.height / 2)) < 360;
    btn.setAttribute('data-flip-up', flipUp ? 'true' : 'false');
  }

  function clearFixed(btn) {
    var pop = popoverOf(btn);
    if (!pop) return;
    pop.style.position = '';
    pop.style.zIndex = '';
    pop.style.right = '';
    pop.style.bottom = '';
    // Vrat puvodni left/top, aby popover pri zaviraci animaci zustal u bodu
    // a "neutekl" do leveho rohu.
    pop.style.left = pop.dataset.pzOrigLeft || '';
    pop.style.top = pop.dataset.pzOrigTop || '';
  }

  // Pri scrollu/resize zavri otevreny fixed popover (na mobilu prekryval
  // displej a "scrolloval s sebou"; zavreni scrollem je prirozenejsi nez
  // honit ho za bodem).
  function closeFixedOpen() {
    document.querySelectorAll('[data-shoppable-fixed]').forEach(function (stage) {
      if (stage.querySelector('[data-hotspot][aria-expanded="true"]')) closeAll(stage);
    });
  }

  function closeAll(stage) {
    var fixed = stage.hasAttribute('data-shoppable-fixed');
    stage.querySelectorAll('[data-hotspot]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      if (fixed) clearFixed(btn);
    });
    stage.removeAttribute('data-open');
  }

  function openHotspot(stage, btn) {
    stage.querySelectorAll('[data-hotspot]').forEach(function (other) {
      other.setAttribute('aria-expanded', other === btn ? 'true' : 'false');
      if (stage.hasAttribute('data-shoppable-fixed') && other !== btn) clearFixed(other);
    });
    if (stage.hasAttribute('data-shoppable-fixed')) {
      positionFixed(btn);
    } else {
      var top = parseFloat(btn.style.top);
      if (!isNaN(top) && top > 55) {
        btn.setAttribute('data-flip-up', 'true');
      }
    }
    stage.setAttribute('data-open', 'true');
  }

  document.addEventListener('click', function (e) {
    var hotspot = e.target.closest('[data-hotspot]');
    if (hotspot) {
      e.stopPropagation();
      var stage = hotspot.closest('[data-shoppable]');
      if (!stage) return;
      var wasOpen = hotspot.getAttribute('aria-expanded') === 'true';
      if (wasOpen) {
        closeAll(stage);
      } else {
        openHotspot(stage, hotspot);
      }
      return;
    }

    var backdrop = e.target.closest('[data-backdrop]');
    if (backdrop) {
      e.stopPropagation();
      var stage = backdrop.closest('[data-shoppable]');
      if (stage) closeAll(stage);
      return;
    }

    document.querySelectorAll('[data-shoppable]').forEach(function (stage) {
      if (!stage.contains(e.target)) closeAll(stage);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-shoppable]').forEach(closeAll);
    }
  });

  window.addEventListener('scroll', closeFixedOpen, true);
  window.addEventListener('resize', closeFixedOpen);

  document.addEventListener('shopify:block:select', function (e) {
    var blockId = e.detail.blockId;
    var btn = document.querySelector('[data-hotspot][data-block-id="' + blockId + '"]');
    if (!btn) return;
    var stage = btn.closest('[data-shoppable]');
    if (!stage) return;
    stage.querySelectorAll('[data-hotspot]').forEach(function (other) {
      other.setAttribute('aria-expanded', other === btn ? 'true' : 'false');
      other.classList.toggle('is-editor-selected', other === btn);
    });
    stage.setAttribute('data-open', 'true');
    if (stage.hasAttribute('data-shoppable-fixed')) positionFixed(btn);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var blockId = e.detail.blockId;
    var btn = document.querySelector('[data-hotspot][data-block-id="' + blockId + '"]');
    if (!btn) return;
    btn.classList.remove('is-editor-selected');
    btn.setAttribute('aria-expanded', 'false');
    var stage = btn.closest('[data-shoppable]');
    if (stage && stage.hasAttribute('data-shoppable-fixed')) clearFixed(btn);
    if (stage && !stage.querySelector('[data-hotspot][aria-expanded="true"]')) {
      stage.removeAttribute('data-open');
    }
  });
})();
